<template lang="pug">
  .card-container.column(:class="{ 'no-margin': !!noMargin }")
    .card-info.item-1.relative.column.space-between
      .color-tag.krea
      .column.info-container.center.middle
        button.add-resource.m-bottom-2.row.center.middle(@click='createResource')
          simple-svg.white-icon(:filepath='addIcon' width='20px' height='20px')
        h2.title-small {{ innerI18n.t('krea.educationalContent.addNewResource') }}
    .card-footer.row.space-between
</template>

<script>
import addIcon from '@/assets/ic_add.svg'
import { mapActions, mapState } from 'vuex'
import { routes } from '../../../router'
import { innerI18n } from '../../../main'

export default {
  props: {
    contentId: { type: Number, required: true }
  },
  data() {
    return {
      addIcon,
      innerI18n,
      noMargin: true
    }
  },
  computed: {
    ...mapState({
      activeLanguage: state => state.kreaEducationalContent.activeLanguage,
      locale: state => state.behavior.locale
    })
  },
  methods: {
    ...mapActions([
      'createKreaResourceByContent',
      'showElement',
      'hideElement'
    ]),
    async createResource() {
      const { success, id } = await this.createKreaResourceByContent({
        locale: this.activeLanguage,
        contentId: this.contentId
      })
      if (success) {
        this.$router.push({
          name: routes.kreaResourcePresentation,
          params: { id },
          query: this.activeLanguage !== this.locale ? { locale: this.activeLanguage } : null
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.add-resource{
  background-color: $blue;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  box-shadow: 0px 0px 4px 2px $shadow-gray2;
}
.card-container{
  height: 260px;
  box-shadow: 0px 5px 4px 0px $shadow-gray1;
}

.card-container.no-margin {
  margin-left: 0;
}

.color-tag {
  background-color: var(--tag-color);
  border-radius: 4px;
  height: 120px;
  max-width: 48px;
  width: 7px;
  position: absolute;
  left: 0;
  top: 50%;
  border: none;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 9px 5px $shadow-gray;
  -webkit-box-shadow: 0px 0px 9px 5px $shadow-gray;
  -moz-box-shadow: 0px 0px 9px 5px $shadow-gray;
  &.krea{
    background: linear-gradient($yellow 33%, $red 33%, $red 66%, $blue 66%);
  }
}

.card-info {
  display: flex;
  flex-direction: column;
  padding: 18px;
  width: 100%;
  .info-container{
    height: 100%;
  }
}

.card-footer {
  align-items: center;
  border-top: 1px solid $light-gray;
  display: flex;
  justify-content: space-between;
  height: 50px;
  padding: 0 20px;
  width: 100%;
  .authors{
    height: 30px;
    width: 30px;
  }
}
</style>
